const gaqlutilNumBoolOrUndefIs = (v, type = typeof v) => (
  type === 'boolean' || type === 'number' || type === 'undefined')

const gaqlutilNumBoolOrStrIs = (o, type = typeof o) => (
  type === 'boolean' || type === 'number' || type === 'string')

const gaqlutilPlainObjIs = ((getproto, objproto = getproto({})) =>
  obj => obj && (getproto(obj) === objproto)
)(Object.getPrototypeOf)

const gaqlutilAsList = value =>
  Array.isArray(value) ? value : [value]

const gaqlutilResStatesMerge = (oldState, aggState) => (
  Object.keys(aggState).reduce((state, key) => {
    if (typeof aggState[key] === 'number') {
      if (typeof state[key] === 'undefined')
        state[key] = 0

      state[key] += aggState[key]
    } else if (Array.isArray(aggState[key])) {
      if (!Array.isArray(state[key]))
        state[key] = []

      ;[].push.apply(state[key], aggState[key])
    }

    return state
  }, oldState))

// use when order not important and sorting helps verify a list
const gaqlutilObjCompareProp = (a, b, prop) => {
  if (a[prop] < b[prop]) return -1
  if (a[prop] > b[prop]) return 1
  return 0
}

const gaqlutilQueryArgsOptGet = (queryArgs, queryOptDefault = {}) => {
  const queryOpt = queryArgs.slice(-1)[0] || {}
  const queryOptIs = typeof queryOpt === 'object'
    && !Array.isArray(queryOpt)

  return queryOptIs
    ? queryOpt
    : queryOptDefault
}

export {
  gaqlutilPlainObjIs,
  gaqlutilNumBoolOrUndefIs,
  gaqlutilNumBoolOrStrIs,
  gaqlutilAsList,
  gaqlutilResStatesMerge,
  gaqlutilObjCompareProp,
  gaqlutilQueryArgsOptGet
}
